import { detailsQueries } from 'src/common/components/Sim/Details/queries/detailsQueries';

type SimProductsDetailProps = {
  iccid: string;
};

export const simProductQueries = {
  root: ['SimProduct'],
  detail: (props: SimProductsDetailProps) => [
    ...detailsQueries.details,
    ...simProductQueries.root,
    props,
  ],
};
